/**
 * Auth Callback Page
 * 
 * Handles OAuth callback and token processing
 */

import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export default function AuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { setTokenAndFetchUser } = useAuthStore()
  const [error, setError] = useState(null)
  
  useEffect(() => {
    const processCallback = async () => {
      const token = searchParams.get('token')
      const errorParam = searchParams.get('error')
      
      if (errorParam) {
        navigate(`/login?error=${encodeURIComponent(errorParam)}`)
        return
      }
      
      if (!token) {
        navigate('/login?error=' + encodeURIComponent('No authentication token received'))
        return
      }
      
      try {
        // Store token and fetch user data
        await setTokenAndFetchUser(token)
        navigate('/', { replace: true })
      } catch (err) {
        console.error('Auth callback error:', err)
        setError('Failed to complete authentication. Please try again.')
        setTimeout(() => {
          navigate('/login?error=' + encodeURIComponent('Authentication failed. Please try again.'))
        }, 2000)
      }
    }
    
    processCallback()
  }, [searchParams, navigate, setTokenAndFetchUser])
  
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-destructive mb-4">
              <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <p className="text-destructive font-medium">{error}</p>
            <p className="mt-2 text-sm text-muted-foreground">Redirecting to login...</p>
          </>
        ) : (
          <>
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
            <p className="mt-4 text-muted-foreground">Signing you in...</p>
          </>
        )}
      </div>
    </div>
  )
}

